export default "__VITE_ASSET__BHliHDmX__"